import React, { useEffect, useState } from 'react';
import DoughnutGauge from './DoughnutGauge';
import BarChart from '../../../common/components/charts/BarChart';
import DashboardCard from './DashboardCard';
import { useApiPortalV1AssessmentsCompletedRetrieveQuery } from 'areas/assessment-schedule/api';
import { useNavigate } from 'react-router';

interface DashboardSurveysCompletedProps {
  assessment_period_id: number;
}

const DashboardSurveysCompleted = ({ assessment_period_id }: DashboardSurveysCompletedProps) => {
  const [departmentScores, setDepartmentScores] = useState([]);
  const [overallCompetion, setOverallCompletion] = useState(0);
  const navigate = useNavigate();

  const { data } = useApiPortalV1AssessmentsCompletedRetrieveQuery({
    assessmentPeriodId: assessment_period_id,
  });

  useEffect(() => {
    if (data) {
      const departmentResponseData = data?.department_responses || [];
      const scores = departmentResponseData
        .map((item: { department_name: string; percent_complete: number }) => ({
          label: item.department_name,
          value: parseFloat((item.percent_complete * 100).toFixed(1)),
        }))
        .sort((a: { label: string }, b: { label: any }) => a.label.localeCompare(b.label));
      setDepartmentScores(scores);
      setOverallCompletion(data.percent_complete * 100 || 0);
    }
  }, [data]);

  return (
    <DashboardCard title="Assessment Completion" onClick={() => navigate('/app/assessments')}>
      <DoughnutGauge complete={overallCompetion} percent={true} size="large" />
      <BarChart data={departmentScores} />
    </DashboardCard>
  );
};
export default DashboardSurveysCompleted;
